<div class="grid-item" [ngClass]="{'on-preview':displayed}">
    <div class="grid-item-details">
        <div class="floating-header">
            <core-helpers-navigation-three-dots-menu [menu]="menu"
                (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
        </div>
        <div class="grid-item-content">
            <div class="item-preview" [title]="file.name" (click)="actionClick.emit(file)">
                <!-- REAL PREVIEW -->
                <div *ngIf="preview != null && preview.status_code == 1 else griditemdimmed">
                    <!-- Display only the page selected hidden the others, but load the next PRELOAD_PAGES pages  -->
                    <ng-container *ngFor="let p of preview.page_properties; let i = index">
                        <core-preview-page-blur *ngIf="i <= (page + PRELOAD_PAGES)" [format]="'small-height'" [hidden]="page != i+1"
                            [fileId]="file.id" [page]="i+1" [property]="p"></core-preview-page-blur>
                    </ng-container>
                    <!-- LEFT ICON FOR PAGE NAVIGATION -->
                    <div class="left-icon" tittle="Previous page" (click)="previousPage($event)"
                        [hidden]="preview.total_pages == 1" 
                        [ngClass]="{'disabled':page == 1}">
                    </div>
                
                    <!-- RIGHT ICON FOR PAGE NAVIGATION -->
                    <div class="right-icon"  tittle="Next page" (click)="nextPage($event)"
                        [hidden]="preview.total_pages == 1"  
                        [ngClass]="{'disabled':page == preview.total_pages}">
                    </div>
                </div>
               <!-- DIMMED PREVIEW -->
                <ng-template #griditemdimmed>
                    <!-- THIS IS THE square dimmed while preview is not loading -->
                    <div class="loader">
                        <div class="dimmed">
                            <div class="dimmed_box"></div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <!-- THIS DATA MUST BE around THE PICTURE SOMEWHERE. 
            - name, donload, size  and extension under the image. 
            - 3 dot menu and the notes bubble on the top corners (notes bubble could be inside a container as well) -->
            <span class="title" [title]="file.name" (click)="actionClick.emit(file)">{{file.name}}</span>

            <div class="size-bubble">   
                <span class="ext">{{getFileExtension(file.name)}} </span><span class="size"> ({{humanFileSize(file.size)}})</span>
                <core-helpers-icons-notes-counter-bubble *ngIf="notes != 0 && notes != null" [title]="notes+' notes'"
                    [letter]="notes" (actionClick)="actionClick.emit(file)"></core-helpers-icons-notes-counter-bubble>
                <span class="download-icon" title="Download" (click)="actionDownloadClick(file,$event)"></span>
            </div>

        </div>
       
    </div>
</div>